import {
  FiltersGroup,
  TagControl,
  TagsControl
} from '@elfsight/widget-filters';
import { useLingui } from '@lingui/react/macro';
import { useSettings } from '@wu/widget-core';
import type { FiltersStyle } from '../../../../types';

type OpenNowProps = {
  type: FiltersStyle;
};

export const OpenNow = ({ type }: OpenNowProps) => {
  const { backgroundColor } = useSettings();
  const { t } = useLingui();

  if (type === 'inline') {
    return (
      <TagControl
        label={t`Open Now`}
        value="openNow"
        filterName="openNow"
        backgroundColor={backgroundColor}
        buttonStyles={{ boxShadow: '0 4px 12px 0 rgba(0, 0, 0, 0.3)' }}
        withBackground
      />
    );
  }

  return (
    <FiltersGroup>
      <TagsControl
        filterName="openNow"
        options={[{ value: 'openNow', label: t`Open Now` }]}
      />
    </FiltersGroup>
  );
};
